import {RfElementType, RplType} from '../redux/types';
import {roomsDataHermes as roomsDataHermesSelectorFn} from '../selectors/index';

/**
 * roomsDataFromHermes + currentFilters = filtered rooms;
 */

const dictRepeatedNumbersInListVsCount = list => {
  return list.reduce((acc, currentVal) => {
    return {
      ...acc,
      [currentVal]: acc[`${currentVal}`] ? acc[currentVal] + 1 : 1,
    };
  }, {});
};

const getFilteredRooms = ({
  currentFilters = [],
  roomsDataFromHermes,
}: {
  currentFilters: RfElementType[];
  roomsDataFromHermes: ReturnType<typeof roomsDataHermesSelectorFn>;
}) => {
  /**
   * No filters are applied return rooms data from hermes as is
   */
  if (!currentFilters.length) {
    return roomsDataFromHermes;
  }

  const filteredRoomsAndRoomFlavors = roomsDataFromHermes
    .map(
      (
        roomFromHermes: ReturnType<typeof roomsDataHermesSelectorFn>[0],
        roomIndex: number,
        roomsFromHermes: ReturnType<typeof roomsDataHermesSelectorFn>,
      ) => {
        const allFiltersWantThisRoomMap = currentFilters.every(filter => {
          return filter.fd.some(filterToRoomMap => {
            return filterToRoomMap.rti === roomIndex;
          });
        });

        if (!allFiltersWantThisRoomMap) {
          return false;
        }

        const filtersWantWhichRoomsFlavorMap = currentFilters.map(filter => {
          return filter.fd.filter(filterToRoomMap => {
            return filterToRoomMap.rti === roomIndex;
          })[0].grpil;
        });

        const roomFlavorIndexesWhichAllFiltersWant = filtersWantWhichRoomsFlavorMap.flat();

        const aRoomFlavorShouldBeRepeatedThisManyTimesInFlattenedRoomFlavors =
          filtersWantWhichRoomsFlavorMap.length;

        const hashMapRoomFlavorIndexVsHowManyTimesTheyAreNeededByAllFiltersCollectively = dictRepeatedNumbersInListVsCount(
          roomFlavorIndexesWhichAllFiltersWant,
        );

        const roomFlavorIndexesWhichAreRequiredByAllFilters = Object.keys(
          hashMapRoomFlavorIndexVsHowManyTimesTheyAreNeededByAllFiltersCollectively,
        ) // keys are room flavor indexes
          .filter(roomFlavorIndex => {
            const countOfRoomFlavor =
              hashMapRoomFlavorIndexVsHowManyTimesTheyAreNeededByAllFiltersCollectively[
                roomFlavorIndex
              ];

            return (
              countOfRoomFlavor === aRoomFlavorShouldBeRepeatedThisManyTimesInFlattenedRoomFlavors
            );
          });

        if (!roomFlavorIndexesWhichAreRequiredByAllFilters.length) {
          return {
            ...roomFromHermes,
            rpl: [],
          };
        }

        let filteredRoomFlavorsInRoom = [] as RplType[];

        roomFlavorIndexesWhichAreRequiredByAllFilters.forEach(roomFlavorIndex => {
          // to be safe
          const roomHasThatRoomFlavor = roomsDataFromHermes[roomIndex]?.rpl[roomFlavorIndex];
          filteredRoomFlavorsInRoom.push(roomHasThatRoomFlavor);
        });

        return {
          ...roomFromHermes,
          rpl: filteredRoomFlavorsInRoom,
        };
      },
    )
    .filter(room => {
      return !!room?.rpl?.length;
    });

  return filteredRoomsAndRoomFlavors;

  // let filteredRooms = [];
  // currentFilters.forEach((data) => {
  //   data.fd.forEach((item) => {
  //     const roomFlavorsList = [];
  //     item.grpil.forEach((grpi) => {
  //       if (roomsDataFromHermes[item.rti].rpl[grpi]) {
  //         roomFlavorsList.push(roomsDataFromHermes[item.rti].rpl[grpi]);
  //       }
  //     });
  //     const roomData = {...roomsDataFromHermes[item.rti]};
  //     roomData.rpl = roomFlavorsList;
  //     filteredRooms.push(roomData);
  //   });
  // });

  // return filteredRooms;
};

export default getFilteredRooms;
